import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'defaultIfNull' })
export class DafaultIfNullPipe implements PipeTransform {

  transform(item: any, defaultValue?: any): any {
      const NBSP = '\u00A0';
      defaultValue = defaultValue || NBSP;
      if (item) {
        return item;
      }
      return defaultValue;
  }

}
